import {
  BinocularsIcon,
  CheckCircleIcon,
  GlobeIcon,
  HomeIcon,
  LifeBuoyIcon,
  LinkIcon,
  SettingsIcon,
  SparklesIcon,
  Target,
  UserRound,
} from 'lucide-react'
import { SidebarSection, type TSidebarItem } from '@/components/app/sidebar/types'
import { MemberRole, UserRole } from '@/lib/auth/types'
import { linksConfig } from './links'

export type TSidebarConfig = Record<SidebarSection, TSidebarItem[]>

export const sidebarConfig: TSidebarConfig = {
  [SidebarSection.MAIN_MY_ASSETS]: [
    {
      title: 'My Domains',
      url: '/app/domains',
      icon: GlobeIcon,
    },
    {
      title: 'My URLs',
      url: '/app/urls',
      icon: LinkIcon,
    },
    // {
    //   title: 'My Keywords',
    //   url: '/app/keywords',
    //   icon: KeyRound,
    // },
  ] satisfies TSidebarItem[],
  [SidebarSection.MAIN_PROSPECTING]: [
    {
      title: 'Prospect Domains',
      url: '/app/prospect-domains',
      icon: BinocularsIcon,
    },
    {
      title: 'Prospect URLs',
      url: '/app/prospect-urls',
      icon: Target,
    },
    // {
    //   title: 'SERP Tracking',
    //   url: '/app/serps',
    //   icon: SearchIcon,
    // },
  ] satisfies TSidebarItem[],
  [SidebarSection.MAIN_OPPORTUNITIES]: [
    {
      title: 'Opportunities',
      url: '/app/backlink-opportunities',
      icon: SparklesIcon,
    },
  ] satisfies TSidebarItem[],
  [SidebarSection.MAIN_MONITORING]: [
    {
      title: 'Acquired Backlinks',
      url: '/app/backlinks',
      icon: CheckCircleIcon,
    },
  ] satisfies TSidebarItem[],
  [SidebarSection.ORG]: [
    {
      title: 'Settings',
      tooltip: 'Organization Settings',
      url: '/app/settings/general',
      icon: SettingsIcon,
      permissions: {
        roles: [MemberRole.OWNER, MemberRole.ADMIN],
      },
    },
  ],
  [SidebarSection.ADMIN]: [
    {
      title: 'Users',
      tooltip: 'Users Table',
      url: '/app/admin/users',
      icon: UserRound,
      permissions: {
        roles: [UserRole.SUPERADMIN],
      },
    },
  ],
  [SidebarSection.SECONDARY]: [
    {
      id: 'support',
      title: 'Support',
      url: linksConfig.discord,
      icon: LifeBuoyIcon,
    },
    {
      title: 'Homepage',
      url: '/',
      icon: HomeIcon,
    },
  ],
} as const
